module.exports = __webpack_public_path__ + "img/revexpo_1360.39a7221c.jpg";